<template>
  <div class="home-page pa-6" v-if="company">
    <company-menu-food-preview-dialog
      v-if="menu"
      v-model="previewDialog"
      :daily-menu="menu"
    >
    </company-menu-food-preview-dialog>
    <user-location-dialog
      v-model="dialogs.userLocation"
      :user-location="userLocation"
      :all-user-location="allUserLocations"
      :new-user-location="newUserLocation"
      @all-user-location-updated="updateAllUserLocations"
      @update-new-user-location="updateNewUserLocation"
    />

    <company-menu-new-restaurant-dialog
      v-model="dialogs.newRestaurant"
      @restaurantChoosen="fetchMenus"
    />

    <order-details-dialog v-model="dialogs.orderDetails" />
    <meal-rating-prompt v-if="user.type === 'customer'" />
    <!-- Reservation Info -->
    <!-- <reservation-info :restaurant="restaurant" v-if="!device.isMobile" /> -->
    <!-- Partner Cards -->
    <partner-cards
      v-if="company.contract == 4"
      :partners="partners"
      @openOrdera="openOrdera"
    />
    <template v-else>
      <!-- Day navigation and company select -->
      <div
        class="rounded-lg"
        style="border: 1px solid rgba(0, 0, 0, 0.1)"
        :class="device.isMobile ? 'mb-4' : 'mb-8'"
      >
        <v-row align="center" class="py-3">
          <v-col
            v-if="restaurantLogoUrl || !device.isMobile"
            sm="4"
            cols="12"
            :align="device.isMobile ? 'center' : 'start'"
            :class="{ 'pb-0': device.isMobile }"
          >
            <img
              v-if="restaurantLogoUrl"
              :src="restaurantLogoUrl"
              :alt="restaurant.name"
              class="restaurant-logo ml-sm-4"
              :class="{ 'restaurant-logo--mobile': device.isMobile }"
            />
          </v-col>
          <v-col sm="4" cols="12" align="center">
            <span class="title font-weight-medium">
              {{
                localeDate(currentMenuDate, {
                  weekday: "long",
                })
              }}
            </span>
            <v-row no-gutters justify="center" align="center">
              <circle-button
                icon="mdi-chevron-left"
                @click="loadDayMenu(-1)"
                large
                color="primary"
                :small="false"
              />

              <p
                v-if="currentMenuDate"
                style="
                  color: rgba(0, 0, 0, 0.87);
                  font-family: 'Poppins', Helvetica, sans-serif !important;
                  font-weight: 700;
                "
                align="center"
                class="px-2 datum mb-2 mt-2 dan-u-nedelji"
              >
                {{ localeDate(currentMenuDate) }}
              </p>
              <circle-button
                icon="mdi-chevron-right"
                @click="loadDayMenu(1)"
                color="primary"
                :small="false"
                large
              />
            </v-row>
            <autocomplete
              v-if="allUserLocations?.length > 1"
              class="pt-4"
              :items="allUserLocations"
              v-model="selectedCompany"
              :label="$t('select_company')"
              item-value="id"
              item-text="name"
              return-object
            />
          </v-col>
          <v-col
            sm="4"
            cols="12"
            :align="device.isMobile ? 'center' : 'end'"
            v-if="!noDailyOrders"
          >
            <primary-button
              v-if="user.type === 'company'"
              @click="previewDialog = true"
              class="mr-2"
            >
              {{ $t("show_order") }}
            </primary-button>
          </v-col>
        </v-row>
      </div>
      <v-progress-linear indeterminate v-if="loading" />
      <v-row
        justify="center"
        align="center"
        class="text-h5"
        v-else-if="!menu && company.type !== 'more_restaurants'"
      >
        {{ $t("no_menu") }}
      </v-row>
      <!-- Menu Day Cards -->
      <daily-menu-section v-if="menu" :item="menu" />
    </template>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import conf from "@/config";
import ReservationInfo from "@/components/companyMenu/ReservationInfo.vue";
import PartnerCards from "@/components/companyMenu/PartnerCards.vue";
import DailyMenuSection from "@/components/companyMenu/DailyMenuSection.vue";
import UserLocationDialog from "@/components/dialogs/UserLocationDialog.vue";
import CompanyMenuNewRestaurantDialog from "@/components/companyMenu/dialogs/CompanyMenuNewRestaurantDialog.vue";
import CompanyMenuFoodPreviewDialog from "@/components/companyMenu/dialogs/CompanyMenuFoodPreviewDialog.vue";
import OrderDetailsDialog from "@/components/dialogs/OrderDetailsDialog.vue";
import MealRatingPrompt from "@/components/companyMenu/MealRatingPrompt.vue";
import moment from "moment";
import { changeDay } from "@/utils/dayShiftUtil";
import restaurantService from "@/services/restaurant";
import companyService from "@/services/company";
import hasSnackbar from "@/mixins/hasSnackbar";

export default {
  mixins: [hasSnackbar],
  components: {
    ReservationInfo,
    PartnerCards,
    DailyMenuSection,
    UserLocationDialog,
    CompanyMenuNewRestaurantDialog,
    CompanyMenuFoodPreviewDialog,
    OrderDetailsDialog,
    MealRatingPrompt,
  },
  data: () => ({
    previewDialog: false,
    locations: [],
  }),
  computed: {
    test() {
      return true;
    },
    noDailyOrders() {
      return (this.menu?.shifts || []).every((shift) =>
        shift.meals.every((meal) => !meal.order)
      );
    },
    ...mapState("companyMenu", [
      "menus",
      "menu",
      "dialogs",
      "selectedCompany",
      "userLocation",
      "allUserLocations",
      "newUserLocation",
      "partners",
      "loading",
      "minOrderDate",
      "currentMenuDate",
    ]),
    company() {
      return this.$store.state.company;
    },
    canChangeOffices() {
      return this.$store.state.user.orderRules.canChangeOffices && this.company.parent_id;
    },
    restaurant() {
      if (this.$store.state.restaurant == null && this.company == null) {
        this.dialogNewRestoran = true;
      } else {
        return this.$store.state.restaurant
          ? this.$store.state.restaurant
          : this.company.restaurant;
      }
    },
    restaurantLogoUrl() {
      if (!this.restaurant?.settings?.logo) {
        return null;
      }
      return `${conf.apiUrlBase}/gallery/${this.restaurant.id}/${this.restaurant.settings.logo}`;
    },
    restaurantId() {
      if (this.$store.state.company) {
        return this.$store.state.company.restaurant.id;
      } else if (this.$store.state.restaurant) {
        return this.$store.state.restaurant.id;
      } else return null;
    },
    conf() {
      return conf;
    },
    user() {
      return this.$store.state.user.user || {};
    },
  },
  methods: {
    ...mapActions("companyMenu", [
      "fetchMenus",
      "updateAllUserLocations",
      "updateNewUserLocation",
      "openOrdera",
    ]),
    changeDay,
    loadDayMenu(daysAmount = 1) {
      const nextDate = moment(this.currentMenuDate).add(daysAmount, "days");
      this.$store.dispatch("companyMenu/fetchMenus", nextDate.format("YYYY-MM-DD"));
    },
    getRestaurantSettingsApi() {
      restaurantService
        .getRestaurantNewTimes(this.restaurantId)
        .then((res) => {
          this.$store.commit("companyMenu/SET_ORDER_TIMES", res.data.data);
          this.fetchMenus();
        })
        .catch((error) => {
          this.showErrorSnackbar(error, this.$t("error_loading_restaurant_times"));
        });
    },
    getRestaurantSettings() {
      const companies = this.$store.state.companies;
      if (!companies || companies.length === 0) {
        this.getRestaurantSettingsApi();
        return;
      }
      const settings = JSON.parse(companies[0].settings);
      if (settings?.global_restaurant_time_settings) {
        this.$store.commit("companyMenu/SET_ORDER_TIMES", settings.days);
        this.fetchMenus();
      } else {
        return this.getRestaurantSettingsApi();
      }
    },
    fetchLocations() {
      this.$store.dispatch("companyMenu/fetchCompanies", this.company.parent_id);
    },
  },
  created() {
    this.getRestaurantSettings();
  },
  watch: {
    canChangeOffices: {
      handler(newVal) {
        if (newVal) {
          this.fetchLocations();
        }
      },
      immediate: true,
    },
  },
  mounted() {
    if (!this.partners.length && this.company && this.company.id) {
      companyService.getCompanyRestaurants(this.company.id).then((res) => {
        this.$store.commit("companyMenu/SET_PARTNERS", res.data);
        if (res.data.length === 1) {
          // this.openOrdera(res.data[0]);
        }
      });
    }
  },
};
</script>

<style scoped>
.restaurant-logo {
  display: inline-block;
  max-height: 96px;
  max-width: 100%;
  object-fit: contain;
}
.restaurant-logo--mobile {
  max-height: 56px;
}
</style>
